import { render, staticRenderFns } from "./credit.vue?vue&type=template&id=8cb62aac&scoped=true&"
var script = {}
import style0 from "./credit.vue?vue&type=style&index=0&id=8cb62aac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb62aac",
  null
  
)

export default component.exports